import { createContext as a, useState as b, useEffect as G, useContext as j, useMemo as v } from "react";
import { u as I } from "./use-unique-id-BA9hSqap.js";
const f = a({});
f.displayName = "FormControlGroupContext";
const M = ({
  defaultValues: o,
  disabled: m,
  id: C,
  name: n,
  state: s = "",
  size: r = "md",
  values: c
}) => {
  const e = o !== void 0, i = I("form-control-group", C), [d, t] = b({
    disabled: m,
    id: i,
    name: n,
    size: r,
    state: s,
    values: e ? o : c || []
  });
  return G(() => {
    t({
      disabled: m,
      id: i,
      name: n,
      size: r,
      state: s,
      values: c ?? (e ? o : [])
    });
  }, [
    o,
    m,
    i,
    n,
    r,
    s,
    e,
    c
  ]), [d, t];
}, N = a({});
N.displayName = "FormControlContext";
const U = ({
  defaultValue: o,
  id: m,
  name: C,
  onChange: n,
  resize: s = !1,
  type: r = "text",
  value: c,
  brand: e,
  ...i
}) => {
  const d = o !== void 0, t = j(f), u = I("form-control", m), x = i.disabled || t.disabled || !1, l = i.state || t.state || "", p = i.size || t.size || "md", [F, S] = b({
    disabled: x,
    id: u,
    name: C,
    onChange: n,
    resize: s,
    size: p,
    state: l,
    type: r,
    value: d ? o : c || "",
    brand: e
  });
  return G(() => {
    S({
      disabled: x,
      id: u,
      name: C,
      onChange: n,
      resize: s,
      size: p,
      state: l,
      type: r,
      value: c ?? (d ? o : ""),
      brand: e
    });
  }, [
    o,
    x,
    u,
    C,
    n,
    s,
    p,
    l,
    r,
    d,
    c,
    e
  ]), [v(
    () => ({
      ...F,
      inGroup: !!t.id
    }),
    [F, t]
  ), S];
};
export {
  N as F,
  f as a,
  U as b,
  M as u
};
//# sourceMappingURL=FormControlContext-C7A4R-3o.js.map
